import SingleCardDetails from "./SingleCardDetails";
import SingleCardContent from "./SingleCardContent";
import CustomButton from "../CustomButton";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { screenSizeContext } from "@/app/store/context/screenSizesContext";
import { useContext } from "react";
import * as gtag from "@/app/utils/gtag";

// interface Details {
// 	label: string
// 	value: string
// }

interface SingleUnitCardContentProps {
	data: any;
	facility?: boolean;
	setMasterplanSelectedUnit?: React.Dispatch<React.SetStateAction<any>>;
	setActiveUnitCard?: React.Dispatch<React.SetStateAction<boolean>>;
	insideAmenitiesDetailsPage?: boolean
}
const SingleUnitCardContent: React.FC<SingleUnitCardContentProps> = ({
	data,
	facility,
	setMasterplanSelectedUnit,
	setActiveUnitCard,
	insideAmenitiesDetailsPage
}) => {
	gsap.registerPlugin(ScrollToPlugin);
	const { isIpad } = useContext(screenSizeContext);

	return (
		<div className="flex justify-between flex-col lg:flex-row gap-[2.44rem] lg:gap-[6.44rem] h-full min-h-0">
			{/* {facility && (
				<div className="img-wrapper relative w-[8rem] h-[6.6rem]">
					<Image
						src={"/images/neighborhoods/popupCard/logo.png"}
						alt="img"
						fill
					/>
				</div>
			)}  */}
			<SingleCardContent
				data={data}
				facility={facility}
				setMasterplanSelectedUnit={setMasterplanSelectedUnit}
				setActiveUnitCard={setActiveUnitCard}
				insideAmenitiesDetailsPage={insideAmenitiesDetailsPage}
			/>
			<div className="col2 w-[100%] lg:w-[40%]">
				<div className="details flex flex-col gap-6 ">
					<SingleCardDetails data={data} facility={facility} />
				</div>
			</div>
			{isIpad && !insideAmenitiesDetailsPage && (
				<div>
					<CustomButton
						text={"Buy now"}
						action={() => {
							gtag.conversion('s22iCL--jN8bELy50MNC');
							const getInTouchSection = document.getElementById("get_in_touch");

							if (getInTouchSection) {
								gsap.to(window, {
									duration: 1,
									scrollTo: getInTouchSection as any,
								});
								if (setMasterplanSelectedUnit && setActiveUnitCard) {
									setActiveUnitCard(false);
									setMasterplanSelectedUnit(data?.id);
								}
							}
						}}
						hasIcon
						style="blue"
						customClass="flex-1 w-fit "
						url={""}
					/>
				</div>
			)}
		</div>
	);
};

export default SingleUnitCardContent;
